import React from "react";
import OpenModalButton from "../../common/components/openModalButton";
import { InterventoDto } from "../../generated";
import { InterventoEdit, InterventoNew } from "./InterventoForm";

export const EditInterventoButton: React.FC<{ title?: string, className: string, idIntervento?: number, idImpianto?: number, idCliente?: number, style?: React.CSSProperties }>
    = ({ idImpianto, className, idIntervento, idCliente, title, style, children }) => {

        let modal = React.createRef<OpenModalButton>();
        return <OpenModalButton
            ref={modal}
            title={title}
            className={className}
            style={style}
            modalContent={<InterventoComponent
                key={-1}
                afterSave={() => modal.current?.close()}
                afterDelete={() => modal.current?.close()}
                onCancel={() => modal.current?.close()}
                id={idIntervento}
                idCliente={idCliente ?? undefined}
                idImpianto={idImpianto ?? undefined}
            />}
        >
            {children}
        </OpenModalButton>
    }


export const InterventoComponent = ({ id, idCliente, idImpianto, onCancel, afterSave, afterDelete }: {
    id?: number,
    idCliente?: number,
    idImpianto?: number,
    onCancel: () => void,
    afterSave: (intervento: InterventoDto) => void
    afterDelete?: (intervento: InterventoDto) => void
}) => {
    if (id && idCliente) {
        return <InterventoEdit
            onCancel={onCancel}
            idClienteStr={idCliente.toString()}
            idImpianto={idImpianto ?? null}
            id={id}
            afterSave={afterSave}
            afterDelete={afterDelete}
        />
    }
    else {
        return <InterventoNew
            idImpianto={idImpianto ?? null}
            idCliente={idCliente ?? null}
            afterSave={afterSave}
            onCancel={onCancel}
        />
    }
}